import { render, staticRenderFns } from "./SoundGroup.vue?vue&type=template&id=0831778b&scoped=true"
import script from "./SoundGroup.vue?vue&type=script&lang=ts"
export * from "./SoundGroup.vue?vue&type=script&lang=ts"
import style0 from "./SoundGroup.vue?vue&type=style&index=0&id=0831778b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831778b",
  null
  
)

export default component.exports